export const ADD_BRIDGE_REQUEST = 'ADD_BRIDGE_REQUEST'
export const REMOVE_BRIDGE_REQUEST = 'REMOVE_BRIDGE_REQUEST'
